export const getIsEvoVerificationPerformed = (response: string | undefined): boolean =>
  ["success", "failed"].includes(response ?? "");
